/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable radix */
import { useEffect, useState } from "react";
import { useDebounce } from "use-debounce";
import TableHeadingTitle from "../../../../../shared/TableHeadingTitle/TableHeadingTitle";
import SearchBar from "../../../../../shared/SearchBar/SearchBar";
import { searchUsers } from "../../../../../store/features/AdminPanel/User/UserSlice";
import { RootStore, useAppDispatch, useAppSelector } from "../../../../../store/store";
import { getAllTrialUser, searchTiralUserDB, searchUsersFromDB } from "../../../../../store/features/AdminPanel/User/UserApi";

const TrialUserHeader = (props: any) => {

  const [searchText, setSearchText] = useState("");
    const [debounceSearchtext] = useDebounce(searchText,500);
  const dispatch = useAppDispatch();
   const userState: any = useAppSelector((store: RootStore) => {
      return store.UserSlice;
    });

  // useEffect(() => {
  //   dispatch(searchUsers(searchText));
  // }, [searchText]);
     // Effect to handle search and load users based on debouncedSearchText
    useEffect(() => {
      if (debounceSearchtext) {
        // If there's a debounced search text, call the search API
        dispatch(searchTiralUserDB({ value: debounceSearchtext }));
      } else {
        // Otherwise, if the search text is empty, load all users with pagination
        dispatch(getAllTrialUser({ page: userState?.current_page }));
      }
    }, [debounceSearchtext, dispatch, userState?.current_page]);

  return (
    <div className="user__table__header_container">
      <div className="left__section">
        <TableHeadingTitle>Trial Users</TableHeadingTitle>
      </div>
      <div className="right__section">
        <div className="search__box">
          <SearchBar value={searchText} setValue={setSearchText} />
        </div>
      </div>
    </div>
  );
};

export default TrialUserHeader;
